import { PolygraphyProductFormat } from '../../../../../services/exports/Constants';

export default {
  form: {
    name: {
      label: 'Diesen Druckauftrag benennen',
      placeholder: 'A5-Flyer - Sonderangebot',
    },
    format: {
      label: 'Produkttyp',
      placeholder: 'Produkttyp auswählen',
      options: {
        [PolygraphyProductFormat.FlyerA5]: 'Flyer (A5)',
        [PolygraphyProductFormat.FlyerA6]: 'Flyer (A6)',
        [PolygraphyProductFormat.Sticker60x60]: 'Aufkleber (60x60mm)',
        [PolygraphyProductFormat.DoorStickerA5]: 'Tür Sticker (30x30cm)',
      },
    },
    file: {
      label: 'Datei',
    },
  },
  buttons: {
    upload: 'Klicken oder ziehen, um Datei hochzuladen',
    save: 'Speichern',
  },
  toasts: {
    changes_got_saved: 'Änderungen wurden gespeichert!',
  },
};
